import { atom } from 'recoil'

export const spinnerState = atom({
    key: 'spinnerState',
    default: false
});